export default {
  home_about: {
    badge: 'Über AllChinaBuy Sheet',
    title: 'Ihr ultimativer\nEinkaufsbegleiter',
    p1: 'Das AllChinaBuy Spreadsheet ist für Tausende von cleveren Shopperinnen und Shoppern weltweit zum unverzichtbaren Werkzeug geworden. Ob Sie nach den neuesten Sneaker-Releases, Premium-Streetwear-Teilen oder versteckten Luxus-Schätzen suchen — ein gut organisiertes Spreadsheet spart Stunden beim Stöbern.',
    p2: 'Unser AllChinaBuy Spreadsheet 2026 Verzeichnis vereint die umfangreichste Sammlung von verifizierten Funden — von Schuhen und Hoodies bis hin zu Taschen, Accessoires und vielem mehr. Jeder Eintrag wird regelmäßig aktualisiert.',
    p3: 'Was unser Verzeichnis auszeichnet, ist das Kurationsniveau. Jeder Eintrag wird manuell auf Genauigkeit und Relevanz geprüft.',
    cta1: 'Hauptshop besuchen',
    cta2: 'Vollständigen Guide lesen',
  },
  home_trust: {
    badge: 'Warum uns wählen',
    title: 'Von Tausenden Shopperinnen und Shoppern vertraut',
    subtitle: 'Unser AllChinaBuy Spreadsheet Verzeichnis basiert auf Zuverlässigkeit, Aktualität und echten Nutzerfeedbacks.',
    t1: 'Wöchentlich aktualisiert',
    t1d: 'Unser Verzeichnis wird jede Woche mit den neuesten Funden aktualisiert, damit Sie keinen neuen Drop verpassen.',
    t2: 'Qualität geprüft',
    t2d: 'Jedes Spreadsheet wird vor der Auflistung manuell überprüft. Wir prüfen auf tote Links, veraltete Preise und ungenaue Produktbeschreibungen.',
    t3: 'Organisierte Kategorien',
    t3d: 'Browse durch 14 sorgfältig organisierte Kategorien — von Sneakern und Hoodies bis zu Accessoires und Dufüten — um genau das zu finden, was Sie suchen.',
    t4: 'Schnelle Navigation',
    t4d: 'Direkte Links zu verifizierten Produkteinträgen eliminieren Rätselraten und bringen Sie schneller vom Stöbern zum Kaufen.',
    t5: 'Vergleichsguides',
    t5d: 'Seite-an-Seite-Vergleiche helfen Ihnen, verschiedene Spreadsheet-Optionen, Preisstufen und Agenten-Empfehlungen vor dem Kauf zu bewerten.',
    t6: 'Neueste Funde',
    t6d: 'Bleiben Sie mit frühzeitigem Zugang zu neu entdeckten Schätzen und unbekannten Schnappschüssen in allen Kategorien immer einen Schritt voraus.',
  },
  home_articles: {
    badge: 'Neueste Guides',
    title: 'Expertenartikel & Ressourcen',
    subtitle: 'Tauchen Sie tiefer in die Welt der AllChinaBuy Spreadsheets ein mit ausführlichen Guides, Vergleichsartikeln und Expertentipps.',
    more: 'Weitere Guides kommen bald — setzen Sie ein Lesezeichen und kommen Sie wöchentlich für neue Inhalte zurück.',
  },
  home_faq: {
    badge: 'FAQ',
    title: 'Häufig gestellte Fragen',
    subtitle: 'Alles, was Sie über AllChinaBuy Spreadsheets wissen müssen und wie Sie das Meiste aus unserem Verzeichnis herausholen.',
    q1: 'Was ist ein AllChinaBuy Spreadsheet?',
    a1: 'Ein AllChinaBuy Spreadsheet ist eine kuratierte Liste von Produktlinks in einem Tabellenformat, die typischerweise in der Rep- und Streetwear-Community geteilt wird. Diese Spreadsheets enthalten direkte Links zu Artikeln, die über den AllChinaBuy-Agentendienst gekauft werden können.',
    q2: 'Wie oft werden die Spreadsheets aktualisiert?',
    a2: 'Unser Verzeichnis wird wöchentlich aktualisiert. Jede Woche prüft unser Team neue Einträge, verifiziert bestehende Links und fügt frische Funde in allen 14 Kategorien hinzu.',
    q3: 'Wie verwende ich ein Spreadsheet, um eine Bestellung aufzugeben?',
    a3: 'Durchsuchen Sie unser Verzeichnis und finden Sie ein Produkt. Klicken Sie zum Hauptshop, um Zugang zum vollständigen Spreadsheet zu erhalten. Kopieren Sie den Link und fügen Sie ihn in die Suchleiste des AllChinaBuy-Agenten ein.',
    q4: 'Sind diese Spreadsheets kostenlos zugänglich?',
    a4: 'Ja, alle im Verzeichnis aufgeführten Spreadsheets sind vollständig kostenlos. Sie zahlen nur für die Artikel, die Sie kaufen möchten, zuzüglich Standard-Agentenpreis und Versandkosten.',
    q5: 'Wie überprüfen Sie die Produktqualität?',
    a5: 'Unser Prüfprozess umfasst die Überprüfung von Verkäuferbewertungen, das Durchsehen von Community-Feedback und QC-Fotos. Nur Spreadsheets mit konstant positivem Feedback werden aufgenommen.',
    q6: 'Kann ich mein eigenes Spreadsheet einreichen?',
    a6: 'Wir begrüßen Community-Beiträge. Wenn Sie ein qualitativ hochwertiges Spreadsheet erstellt haben, das Sie teilen möchten, kontaktieren Sie uns über die Kontaktseite des Hauptshops.',
  },
  home_cta: {
    title: 'Bereit, Ihr nächstes\ntolles Angebot zu finden?',
    subtitle: 'Schließen Sie sich Tausenden von cleveren Shopperinnen und Shoppern an, die bereits unser AllChinaBuy Spreadsheet Verzeichnis nutzen. Wöchentlich aktualisiert.',
    cta1: 'Spreadsheets durchsuchen',
    cta2: 'Guide lesen',
  },
  home: {
  metaTitle: 'AllChinaBuy Spreadsheet — Produkte finden, QC prüfen & smarter shoppen',
  metaDescription:
    'Entdecken Sie das AllChinaBuy-Spreadsheet, um Produktfunde zu finden, Kategorien zu vergleichen, QC zu verstehen und Versandkosten einzuschätzen. Unabhängige Kaufanleitungen an einem Ort.',
  hero: {
    badge: 'Unabhängiger Kaufratgeber',
    title: 'AllChinaBuy Spreadsheet — Produkte finden, QC prüfen & smarter shoppen',
    subtitle:
      'Entdecken Sie das AllChinaBuy-Spreadsheet, finden Sie Produktfunde, vergleichen Sie Kategorien, verstehen Sie QC und Versandkosten und folgen Sie praktischen Kaufanleitungen an einem Ort.',
  },
  what: {
    title: 'Was ist das AllChinaBuy-Spreadsheet?',
    p1: 'Ein AllChinaBuy-Spreadsheet ist eine teilbare, organisierte Liste von Produktfunden — Links, QC-Fotos, Verkäufernotizen und Versandtipps — die Ihnen hilft, mit mehr Sicherheit zu stöbern und zu kaufen. Statt durch endlose Shopseiten zu scrollen, öffnen Sie eine übersichtliche Tabelle und springen direkt zu Artikeln, die zu Ihrem Stil und Budget passen.',
    p2: 'Der eigentliche Wert liegt in der Filterung. Gute Spreadsheets sind nach Kategorien sortiert, markieren, ob ein Artikel bereits bewertet wurde, und enthalten echte QC-Fotos, damit Sie das Rätselraten überspringen und häufige Fehler vermeiden können.',
    p1Title: 'Kuratiert, nicht zufällig',
    p2Title: 'Entwickelt, um Ihnen Zeit zu sparen',
  },
  categories: {
    title: 'Kategorien durchsuchen',
    subtitle: 'Wählen Sie eine Kategorie, um kuratierte Produktfunde zu entdecken.',
    placeholder: 'Kategorie wählen…',
    go: 'Zur Kategorie',
    viewAll: 'Alle Kategorien ansehen',
  },
  articles: {
    title: 'Kaufguides & Artikel',
    subtitle: 'Unabhängige, originale Guides zu AllChinaBuy-Bewertungen, Versand, QC, Coupons, Sicherheit und mehr.',
    readMore: 'Artikel lesen',
  },
  guide: {
    title: 'Neuester Spreadsheet-Guide',
    subtitle:
      'Neu beim Spreadsheet? Beginnen Sie mit unserem vollständigen Guide zu Produktfunden, QC und smartem Einkaufen.',
    cardTitle: 'AllChinaBuy Spreadsheet: Der komplette Guide',
    cardText:
      'Erfahren Sie, wie das Spreadsheet funktioniert, wie Sie es Schritt für Schritt nutzen und worauf Sie vor dem Kauf achten sollten.',
    read: 'Guide lesen',
  },
  faq: {
    title: 'Häufig gestellte Fragen',
    q1: 'Was ist ein AllChinaBuy-Spreadsheet?',
    a1: 'Es ist eine teilbare, organisierte Liste von Produktfunden mit Links, QC-Fotos und Notizen, die Ihnen hilft, mit mehr Sicherheit zu stöbern und zu kaufen.',
    q2: 'Ist dies eine offizielle AllChinaBuy-Website?',
    a2: 'Nein. Dies ist eine unabhängige Informationsquelle und weder mit AllChinaBuy verbunden noch von AllChinaBuy unterstützt.',
    q3: 'Brauche ich das Spreadsheet zum Einkaufen?',
    a3: 'Nein, aber es spart viel Zeit, indem es Ihnen kuratierte Links und echte QC-Fotos liefert, die Sie sonst selbst finden müssten.',
    q4: 'Wie viel kostet der Versand?',
    a4: 'Das hängt von Gewicht, Größe und Versandlinie ab. Leichte Artikel kosten weniger, und das Zusammenfassen von Paketen reduziert in der Regel die Gesamtkosten.',
  },
  finalCta: {
    title: 'Bereit, Ihr nächstes Produkt zu finden?',
    text: 'Durchsuchen Sie die kuratierten Kategorien und starten Sie Ihre nächste Bestellung mit mehr Sicherheit.',
  },
  },
};